import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { authService } from '../../../modules/users/services/dependency.injection';
import { FallbackPageWrapper } from 'react-current-page-fallback';

const AppRoute = ({ component: Component, layout: Layout, isGeneral, isAuthProtected, footer: Footer, ...rest }) => (
    <React.Fragment>
        <Route
            {...rest}
            render={props => {
                if (isAuthProtected && !authService.isAuthenticated()) {
                    console.log('[AppRoute] Protected route, NOT authenticated. Redirecting to /');
                    // clear session if user is not authenticated
                    // setSession(null);
                    // authService.setToken('auth-spay-user', null);
                    return <Redirect to={{ pathname: '/', state: { from: props.location } }} />;
                }
                if (!isAuthProtected && authService.isAuthenticated()) {
                    console.log('[AppRoute] Public route, IS authenticated. Redirecting to /dashboard');
                    return <Redirect to={{ pathname: '/dashboard', state: { from: props.location } }} />;
                }

                return (
                    <React.Fragment>
                        {isAuthProtected ? (
                            <Layout>
                                <Component {...props} />
                            </Layout>
                        ) : isGeneral ? (
                            <React.Fragment>
                                <Component {...props} />
                            </React.Fragment>
                        ) : (
                            <React.Fragment>
                                <FallbackPageWrapper>
                                    <Component {...props} />
                                </FallbackPageWrapper>
                            </React.Fragment>
                        )}
                    </React.Fragment>
                );
            }}
        />
    </React.Fragment>
);

export default AppRoute;
